module.exports = __webpack_public_path__ + "static/video-e9522959deac1949167a2eecc41d7953.mp4";